import React, { useEffect, useState } from 'react'
import { adminRequest } from '../api/client'
import { BackLink, DetailGrid, SummaryGrid, Timeline } from '../components/AdminCommon'
import { Card, EmptyState, PageTitle, StatusBadge, formatCurrency, formatDate } from '../components/Ui'

export default function PaymentDetailLive({ id, navigate }) {
  const [item, setItem] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    let disposed = false
    setItem(null)
    setError('')
    adminRequest(`/api/v1/admin/payments/${encodeURIComponent(id)}`)
      .then((response) => { if (!disposed) setItem(response?.data || null) })
      .catch((nextError) => { if (!disposed) setError(nextError?.message || '결제 정보를 찾을 수 없습니다.') })
    return () => { disposed = true }
  }, [id])

  if (error) return <><BackLink onClick={() => navigate('/payments')} /><Card><EmptyState title="결제 조회 실패" description={error} /></Card></>
  if (!item) return <><BackLink onClick={() => navigate('/payments')} /><PageTitle eyebrow="PAYMENT DETAIL · LIVE DB" title="결제 확인 중" description="difan_dev 결제 원장을 조회하고 있습니다." /><Card><p>실제 결제 정보를 불러오는 중입니다.</p></Card></>

  const transactions = item.transactions || []
  return <>
    <BackLink onClick={() => navigate('/payments')} />
    <PageTitle eyebrow="PAYMENT DETAIL · LIVE DB" title={item.paymentNo} description="DIFAN 주문 원장과 실제 저장된 결제·PortOne 식별자를 확인합니다." />
    <SummaryGrid items={[
      { label: '결제 상태', value: <StatusBadge status={item.status} /> },
      { label: '결제 금액', value: formatCurrency(item.amount) },
      { label: 'PG 수수료', value: item.pgFeeAmount == null ? '미확정' : formatCurrency(item.pgFeeAmount) },
      { label: '결제 시각', value: formatDate(item.paidAt, true) },
    ]} />
    <div className="dashboard-grid half">
      <Card title="결제 원장"><DetailGrid items={[
        { label: '내부 결제 ID', value: item.id },
        { label: '주문 ID', value: item.orderId },
        { label: '주문번호', value: item.orderNo },
        { label: '주문 상태', value: item.orderStatus },
        { label: '고객 ID', value: item.customerId },
        { label: '고객', value: `${item.customerName || '-'} (${item.customerNickname || '-'})` },
        { label: '디렉터 ID', value: item.directorId },
        { label: '디렉터', value: item.directorName || '-' },
        { label: 'Provider', value: item.provider || '-' },
        { label: '통화', value: item.currency || 'KRW' },
      ]} /></Card>
      <Card title="PortOne 식별자"><DetailGrid items={[
        { label: 'paymentId', value: <span className="mono">{item.portonePaymentId || '-'}</span>, wide: true },
        { label: 'PG 수수료 확정일', value: formatDate(item.pgFeeConfirmedAt, true), wide: true },
        { label: '생성일', value: formatDate(item.createdAt, true) },
        { label: '수정일', value: formatDate(item.updatedAt, true) },
      ]} /></Card>
    </div>
    <Card title="결제 거래 이력" description="payment_transactions 실제 레코드입니다.">
      {transactions.length ? <Timeline items={transactions.map((tx) => ({ label: `${tx.status || '거래'} · ${tx.method || '-'}`, detail: `${tx.pgProvider || item.provider || '-'} · ${tx.transactionId || '-'}`, at: formatDate(tx.completedAt || tx.attemptedAt, true) }))} /> : <EmptyState title="저장된 거래 이력이 없습니다." description="결제 준비 상태이거나 아직 승인 거래가 생성되지 않았습니다." />}
    </Card>
    <Card title="데이터 원본"><p className="help-copy">이 화면은 mockData 결제 레코드를 사용하지 않습니다. 결제 ID가 실제 DB에 없으면 404로 처리됩니다.</p></Card>
  </>
}
